import moment from 'moment';
export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	mainResultList: [],

	companySaleList: [], //검색 판매일 셀렉스박스

	selectedRow: SELECTED_ROW(),
	popupSearchParams: POPUP_SEARCH_PARAMS(),
	popupPagingInfo: PAGING_INFO(),
	resultList: [],

	isMqyUser: false,
	readOnlyAuth: true

};

function SEARCH_PARAMS() {
	return {
		srchMm03: '', //날짜구분
		strtMm01: '', //strtMm01
		endMm01: '', //endMm01
		pmcId: '',
		carVin: '',
		cpnyNm: '',
		licensePlate: '',
		lastYn:'',
	};
}

function POPUP_SEARCH_PARAMS() {
	return {
		disabled: false,
		pmcId: '',
		ipnNos: '',
		saveStatus: '' //save 임시저장, register 작성, renew 재작성, changeCust : 업체변경
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SELECTED_ROW() {
	return {
		saveStatus: '', //save 임시저장, register 작성, renew 재작성, changeCust : 업체변경
		pmcId: '', //pmc 번호
		ipnNos: '', //차수
		carVin: '',
		pmcChgrDt: '',
		erpSaleDd: '',
		jvCpnyNm: '',
		ormSaleDd: '',
		oemCpnyNm: '',
		wrntStrtDd: '',
		eil: '',
		licensePlate: '',
		carrierName: '',
		custNm: '',
		chgrId: '',
		chgrNm: '',
		chgrDt: '',
		wrntStrtDdManual: 0,
		wrntStrtDdManualFlag: false
		
	};
}
export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW, POPUP_SEARCH_PARAMS };
